const COOKIE_KEYS = {
  loginEmail: 'loginEmail',
  loginRememberMe: 'loginRememberMe',
};

export default COOKIE_KEYS;
